import React from 'react';
import { Check } from 'lucide-react';

interface PaymentMethodProps {
  id: string;
  name: string;
  icon: string;
  description: string;
  available: boolean;
  selected: boolean;
  onSelect: (id: string) => void;
}

const PaymentMethod: React.FC<PaymentMethodProps> = ({
  id,
  name,
  icon,
  description,
  available,
  selected,
  onSelect
}) => {
  return (
    <div
      onClick={() => available && onSelect(id)}
      className={`p-4 rounded-2xl border-2 cursor-pointer transition-all duration-200 ${
        selected
          ? 'border-purple-500 bg-purple-50 shadow-lg'
          : 'border-gray-200 bg-white/90 hover:border-purple-300'
      } ${!available ? 'opacity-50 cursor-not-allowed' : ''}`}
    >
      <div className="flex items-center gap-3">
        <div className="text-2xl">{icon}</div>
        <div className="flex-1">
          <h4 className="font-semibold text-gray-800">{name}</h4>
          <p className="text-sm text-gray-600">{description}</p>
        </div>
        <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
          selected
            ? 'border-purple-500 bg-purple-500'
            : 'border-gray-300'
        }`}>
          {selected && <Check size={14} className="text-white" />}
        </div>
      </div>
    </div>
  );
};

export default PaymentMethod;